module.exports = __webpack_public_path__ + "img/empresa-comercial-1.e47d18ba.png";